import React, { useState } from 'react'
import edit from './edit.module.css'
import { CiSearch, CiSettings } from 'react-icons/ci'
import imgI from '../../../img/new/7.png'
import imgII from '../../../img/new/8.png'
import imgIII from '../../../img/new/6.png'
import imgIV from '../../../img/logo 1.png'
import imgV from '../../../img/newimage/10.png'
import { Link } from 'react-router'
import { MdOutlineDashboard } from 'react-icons/md'
import { LuFileSliders } from 'react-icons/lu'
import { FaRegCopy } from 'react-icons/fa';
const EditPage = () => {


    const [modal, setModal] = useState(false);
    const [search, setSearch] = useState('')
    const [image, setImage] = useState(null);
    const [copied, setCopied] = useState(false);
 
    const toggleModal = () => {
        setModal(!modal);
      };
    
      if(modal) {
        document.body.classList.add('active-modal')
      } else {
        document.body.classList.remove('active-modal')
      }
  
        
      
        const handleImageUpload = (event) => {
          const file = event.target.files[0];
          if (file) {
            const imageURL = URL.createObjectURL(file);
            setImage(imageURL);
          }
        };

       
        const accessCode = "467BOpnM9580Lmn";
      
        const handleCopy = () => {
          navigator.clipboard.writeText(accessCode);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        };


  return (
    <div className={edit.edit}>
        <div className={edit.container}>
            <div className={edit.contentI}>
                  <img src={imgIV} className={edit.img} alt="" />
            </div>
            <div className={edit.content}>
                <div className={edit.block}>
                    <div className={edit.blocki}>
                            <div className={edit.seci}>
                                <Link to='/Admin/AdminBoard'>
                                <div className={edit.icon}>
                                    <MdOutlineDashboard/>
                                    <h3 >Dashboard</h3>
                                </div>
                                </Link>
                                <Link to='/Admin/AdminBoard/AdminEmploy'>
                                <div className={edit.icon}>
                                    <LuFileSliders  className={edit.word} />
                                    <h3 className={edit.word}> Employees</h3>
                                </div>
                                </Link  >
                                <Link to='/Admin/AdminBoard/AccessCode'>
                                     <div className={edit.icon}>
                                         <LuFileSliders />
                                        <h3>Access Code</h3>
                                    </div>
                            </Link>
                            </div>
                            <div className={edit.seciI}>
                                <div className={edit.icon}>
                                    <CiSettings />
                                    <h3>Settings</h3>
                                </div>
                                <Link to='/Admin'>
                                 <div className={edit.icon}>                               
                                <h3>Logout</h3>
                                 </div>
                                </Link>
                            </div>
                    </div>
                    <div className={edit.blockI}>
                        <div className={edit.flex}>
                            <h3>Edit</h3>
                            <div className={edit.flexIII}>
                                <div className={edit.inp}>
                                    <input type="search"
                                    onChange={(e) => setSearch(e.target.value)}
                                    name="" id="" />
                                    <CiSearch />
                                </div>
                                <img className={edit.imgi} src={imgI} alt="" />
                            </div>
                        </div>
                        <div className={edit.flexI}>
                             <div className={edit.profileImage}>
                                    <label htmlFor="upload-input">
                                    <img className={edit.image} src={image || imgV} alt="Profile" />
                                    </label>
                                    <input
                                    id="upload-input"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleImageUpload}
                                    className={edit.hiddenInput}
                                    />
                                    <button className={edit.uploadBtn}>Upload Image</button>
                            </div>
                            <div className={edit.info}>
                                <div className={edit.row}>
                                <input type="text" placeholder="Name" className={edit.input} />
                                <input type="text" placeholder="Employee’s Role" className={edit.input} />
                                </div>
                                <textarea placeholder="Description" className={edit.textarea}></textarea>
                                <div className={edit.socialLinks}>
                                <input type="text" placeholder="LinkedIn URL" className={edit.input} />
                                <input type="text" placeholder="Twitter URL" className={edit.input} />
                                <input type="text" placeholder="Instagram URL" className={edit.input} />
                                <input type="email" placeholder="Email" className={edit.input} />
                                </div>
                             </div>
                           
                         </div>
                         <div className={edit.bttnI}>
                                        <Link to='/Admin/AdminBoard/AdminEmploy/AdminEdit'>
                                        <button onClick={toggleModal} className={edit.btni}>Add Employee</button>
                                        </Link>
                                        <button className={edit.btnii}>cancel</button>
                                        {modal && (
                                <div className="modal">
                                    <div onClick={toggleModal} className={edit.overlay}></div>
                                        <div className={edit.modalcontent}>
                                            <div className={edit.containerI}>
                                                <img 
                                                    src={imgIII} 
                                                    alt="User" 
                                                    className={edit.profilePic} 
                                                />
                                                <h2 className={edit.name}>Seun Babalola</h2>
                                                <p className={edit.description}>
                                                    The profile of Seun Babalola has been successfully added as a member of the organization.
                                                    An access code has been generated. You cannot revoke or regenerate a new code from the access code panel.
                                                </p>
                                                <div className={edit.codeContainer}>
                                                    <span className={edit.accessCode}>{accessCode}</span>
                                                    <FaRegCopy className={edit.copyIcon} onClick={handleCopy} />
                                                    {copied && <span className={edit.copiedMessage}>Copied!</span>}
                                                </div>
                                                <div className={edit.buttons}>
                                                    <button className={edit.mailButton}>Send to Seun’s Mail</button>
                                                    <button className={edit.dashboardButton}>Continue to Dashboard</button>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                             )}
                            </div>
                    </div>
                    </div>
             </div>
         </div>
    </div>
    
  )
}

export default EditPage
